<mng-frame #frame [needsSidenav]="true" [needsAuth]="true" [logoHref]="" [frameHandler]="frameHandler">
  <ng-template #sidenavTemplate let-sidenavActionDefs>
    <mgs-nav-container [frame]="frame" />
  </ng-template>
</mng-frame>

@if (!isKidsReservierungPath() && !authStateFacade.authenticated()) {
  <div class="bottom-info-container">
    <div class="flex" style="padding-left: 20px; gap: 20px">
      <A href="https://www.merkur.at/rechtliche-hinweise" target="_blank">Rechtliche Hinweise</A>
      <A href="https://www.merkur.at/impressum" target="_blank">Impressum</A>
    </div>

    <div style="color: white; font-size: small; font-weight: bold">v{{ activeState.version() }}</div>
  </div>
}
